<template>
  <v-list-group color="primary" :id='id'>
    <template v-slot:activator>
      <v-list-item-icon class="mr-2">
        <v-icon>{{ group.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title
          style="font-size: 15px"
          v-text="group.label"
        ></v-list-item-title>
      </v-list-item-content>
    </template>
    <slot></slot>
  </v-list-group>
</template>

<script>
export default {
  name: 'SidebarListGroup',
  props: {
    group: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  }
}
</script>
